import { MessageTemplatesService, TemplateCatalog } from "client/openapi";
import { errorText } from "components/Forms/formsApi";
import { useEffect, useState } from "react";
import Notifications from "util/notifications";

/**
 * What the template editor offers (variables, trigger kinds and their
 * choices), loaded once `on` is true; undefined until then.
 */
export function useCatalog(orgId: number, on = true) {
  const [catalog, setCatalog] = useState<TemplateCatalog>();
  useEffect(() => {
    if (!on) return;
    MessageTemplatesService.getMessageTemplateCatalog({ orgId })
      .then(setCatalog)
      .catch((e) =>
        Notifications.error(errorText(e, "The variables could not be loaded."))
      );
  }, [orgId, on]);
  return catalog;
}

/** The variable picker's groups, loaded once `on` is true. */
export function useCatalogVariables(orgId: number, on = true) {
  return useCatalog(orgId, on)?.variables;
}
